exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.option-description[data-v-2bc9badb] {\n    margin-left: 10px;\n    padding: 5px 10px;\n    border: thin solid #cf0;\n}\n.align-center-items[data-v-2bc9badb]{\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n}\n", ""]);

